import { Check } from "lucide-react";
import { LazyNetwork } from "@/components/fx/LazyNetwork";
import { SplitLines } from "@/components/fx/Reveal";
import { LeadForm } from "@/components/form/LeadForm";

const NEXT = ["Ti contattiamo entro 24 ore lavorative", "Chiamata di 20 minuti", "Proposta chiara con tempi e costi"];
const BENEFITS = ["Nessun CV da leggere", "Nessun colloquio da organizzare", "Nessuna ora bruciata", "Solo profili già testati"];

export const FormSection = ({ lines = ["Hai un ruolo", "da coprire?"], text = "Lasciaci due righe su chi cerchi. Ti richiamiamo noi. La prima chiamata è gratuita e non ti impegna a nulla.", note = null, fonte, pagina }) => (
  <section id="richiedi" data-theme="dark" className="rl-section rl-grain relative overflow-hidden bg-[#0F6E56] py-24 text-white lg:py-36" data-testid="form-section">
    <LazyNetwork density={16000} color="231,229,223" amberRatio={0.05} className="opacity-70" />
    <div className="rl-container relative grid gap-14 lg:grid-cols-12 lg:gap-12">
      <div className="lg:col-span-5">
        <p className="rl-eyebrow text-[#BCE3D6]">Richiedi una figura</p>
        <SplitLines className="rl-display mt-6 text-[clamp(2.4rem,4.4vw,4.4rem)]" lines={lines} data-testid="form-title" />
        <p className="mt-8 max-w-[460px] text-lg leading-relaxed text-white/90" data-testid="form-text">
          {text}
        </p>
        <ul className="mt-8 grid gap-3 sm:grid-cols-2" data-testid="form-benefits">
          {BENEFITS.map((b) => (
            <li key={b} className="flex items-center gap-3 text-[15.5px]">
              <span className="inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[#BCE3D6] text-[#0F6E56]"><Check size={13} strokeWidth={3} /></span>
              {b}
            </li>
          ))}
        </ul>
        {note && <p className="mt-8 border-l-2 border-[#EF9F27] pl-4 text-[15px] leading-relaxed text-white/90" data-testid="form-note">{note}</p>}
        <div className="mt-12 border-t border-white/20 pt-8">
          <p className="font-mono-data text-[12px] uppercase tracking-[0.16em] text-[#BCE3D6]">Cosa succede dopo</p>
          <ol className="mt-6 space-y-5" data-testid="form-next-steps">
            {NEXT.map((n, i) => (
              <li key={n} className="flex items-center gap-4">
                <span className="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-white/30 font-mono-data text-sm">{i + 1}</span>
                <span className="text-[17px]">{n}</span>
              </li>
            ))}
          </ol>
        </div>
      </div>
      <div className="lg:col-span-7">
        <div className="rounded-[20px] border border-[#E7E5DF] bg-white p-6 text-[#2C2C2A] shadow-[0_50px_100px_-40px_rgba(0,0,0,0.5)] sm:p-10" data-theme="light">
          <LeadForm fonte={fonte} pagina={pagina} />
        </div>
      </div>
    </div>
  </section>
);
